import { render, staticRenderFns } from "./ButtonComponent.vue?vue&type=template&id=7bd1ec40&scoped=true&"
import script from "./ButtonComponent.vue?vue&type=script&lang=ts&"
export * from "./ButtonComponent.vue?vue&type=script&lang=ts&"
import style0 from "./ButtonComponent.vue?vue&type=style&index=0&id=7bd1ec40&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bd1ec40",
  null
  
)

export default component.exports